module.exports = __webpack_public_path__ + "img/img-jili.60f24602.png";